/* eslint-disable no-unused-vars */

/**
 * ws 订阅类型
 */
export enum NORMAL_SUBSCRIBE_MAP {
  KLINE = 'kline',
  TRADE = 'trade',
  DEPTH = 'depth',
  PRICE = 'price',
  COMMON = 'common',
  INNOVATE = 'innovate',
  P2P_MAIN = 'p2p',
  has = "has",
  get = "get"
}

export const WORKER_MSG_TOPIC = new Map([
  ['SUBSCRIBE', 1],
  ['UNSUBSCRIBE', 2],
])

export const supportTextEncoder = typeof TextEncoder === 'function'
